<header class="background-header classic-background"></header>
<section class="main-side-nav" id="mainSideNav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}"
	*ngIf="showAllUsers == true">
	<section class="container admin-dashboard-parent accounts-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Accounts'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Accounts</h1>
			</div>
		</section>
		<!-- Search -->
		<section class="all-users-line-presentation">
			<div class="search-section">
				<div class="accounts-number">
					<span>{{users.length}} plan holders</span>
				</div>
				<div class="buttons-managment">
					<input type="button" class="btn btn-primary export-btn" value="Export" (click)="exportAsXLSX()">
					<input type="text" class="dashboard-input" placeholder="Last Name" [(ngModel)]="searchData">
					<input type="button" class="btn btn-primary search-btn" value="Search"
						(click)="searchByLastName(searchData)">
				</div>
			</div>
		</section>

		<!-- Table of data sought-->
		<section *ngIf="isSearching == true" class="data-sought-container">
			<app-loader *ngIf="!dataIsLoaded"></app-loader>
			<section class="all-users-data" *ngIf="usersFound">
				<div class="table-responsive admin-dashboard-table">
					<table class="table table-hover table-borderless">
						<thead>
							<tr>
								<th scope="col">First Name</th>
								<th scope="col">Last Name</th>
								<th scope="col">Email</th>
								<th scope="col">Active</th>
								<th scope="col">Last Log In</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let userFound of usersFoundArray" (click)="onSelect(userFound)">
								<td><span>{{userFound.firstName}}</span></td>
								<td><span>{{userFound.lastName}}</span></td>
								<td>{{userFound.email}}</td>
								<td>{{userFound.activated}}</td>
								<td>{{userFound.lastUpdate | date: 'dd/MM/yyyy, h:mm a'}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
			<div *ngIf="usersFound == false">
				<div class="not-found-message">{{message}}</div>
			</div>
			<input *ngIf="dataIsLoaded" type="button" class="btn btn-primary back-table" value="Back"
				(click)="backToTable()">
		</section>

		<!-- Table of data not sought-->
		<section class="all-users-data" *ngIf="isSearching == false">
			<div class="table-responsive admin-dashboard-table">
				<table class="table table-hover table-borderless">
					<thead>
						<tr>
							<th scope="col" (click)="sortColumns('firstName')">First Name <i
									[ngClass]="{'sorted-icon': firstNameSorted==true}" class="fa fas fa-arrow-up"></i>
							</th>
							<th scope="col" (click)="sortColumns('lastName')">Last Name <i
									[ngClass]="{'sorted-icon': lastNameSorted==true}" class="fa fas fa-arrow-up"></i>
							</th>
							<th scope="col" (click)="sortColumns('email')">Email <i
									[ngClass]="{'sorted-icon': emailSorted==true}" class="fa fas fa-arrow-up"></i></th>
							<th scope="col">Active</th>
							<th scope="col">Last Log In</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let dataUser of users" (click)="onSelect(dataUser)">
							<td><span *ngIf="dataUser.firstName">{{dataUser.firstName}}</span></td>
							<td><span *ngIf="dataUser.lastName">{{dataUser.lastName}}</span></td>
							<td>{{dataUser.email}}</td>
							<td>{{dataUser.activated}}</td>
							<td>{{dataUser.lastUpdate | date: 'dd/MM/yyyy, h:mm a'}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
		<app-pagination [currentPage]="page" [totalPages]="totalPages"
			(pageChange)="loadUsers($event)"></app-pagination>
	</section>
</section>
<app-account-details *ngIf="userDetail == true" [dataUser]="selectedUser" (onClick)="backFromDetailUser()"
	(userOutputValue)="displayUserData($event)"></app-account-details>